export default __webpack_public_path__ + "static/media/PD_START.d19256e1.WAV";